import React from 'react'
import { Avatar } from 'antd'
import { connect } from 'react-redux'
import styled from 'styled-components'

import {
  getESuiteMgmtInfo,
  postESuiteMgmtInfo,
  deleteESuiteMgmtInfo,
} from 'api/pgads.js'
import { getApiTargetInfo } from 'core'
import { getCompanyNameMap } from 'core/selectors'
import GenericEditScreen, {
  RowButtons,
  RowContainer,
} from 'core/component/GenericEditScreen'
import { ErrorContext, SpinContext } from 'context'
import { Filler } from '../../../core/screen-util'

import ESuiteModal from './eSuiteModal'

export const CompanyLabel = styled.div`
  font-weight: bold;
  font-size: 1.3em;
`
export const NameLabel = styled.div`
  font-size: 1.3em;
  color: #777;
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
`
export const UrlLabel = styled.div`
  font-size: 1em;
  color: #777;
`
export const Display = styled.div`
  margin-left: 20px;
`

const ESuiteMgmt = props => {
  const retrieveTask = apiTargetInfo => _ => getESuiteMgmtInfo(apiTargetInfo)

  const companyOption = data => {
    const option = []
    Object.keys(data).forEach(key =>
      option.push({ value: key, text: data[key] })
    )
    option.sort((a, b) => (a.value < b.value ? -1 : a.value > b.value ? 1 : 0))
    return option
  }

  const acceptFilter = item => filterText =>
    filterText == null ||
    (props.companyNameMap[item.companyId] || '')
      .toLowerCase()
      .includes(filterText.toLowerCase()) ||
    (item.market || '').toLowerCase().includes(filterText.toLowerCase()) ||
    (item.userName || '').toLowerCase().includes(filterText.toLowerCase())

  const renderModal = ({ hideModal, modalInfo, ...rest }) => (
    <ESuiteModal
      hide={hideModal}
      data={modalInfo}
      resetPassword={postESuiteMgmtInfo}
      companyOption={companyOption(props.companyNameMap)}
      {...rest}
      setError={props.setError}
      setSpinning={props.setSpinning}
    />
  )

  const renderRow = ({ item, style, popModal, onDelete }) => (
    <RowContainer style={style}>
      <Avatar
        style={{
          backgroundColor: '#555',
          marginLeft: '5px',
          minWidth: '70px',
        }}
        size={40}
      >
        {item.market}
      </Avatar>
      <Display>
        <CompanyLabel>{props.companyNameMap[item.companyId]}</CompanyLabel>
      </Display>
      <Display>
        <NameLabel>{item.userName}</NameLabel>
      </Display>
      <Display>
        <UrlLabel>
          <b>Submit URL : </b>
          {item.submitUrl}
        </UrlLabel>
        <UrlLabel>
          <b>Query URL : </b>
          {item.queryUrl}
        </UrlLabel>
        <UrlLabel>
          <b>XMLNS : </b>
          {item.xmlns}
        </UrlLabel>
      </Display>
      <Filler />
      <RowButtons
        item={item}
        onDelete={onDelete}
        popModal={popModal}
        extraButtonEvent={() => popModal({ ...item, resetPass: true })}
        extraButtonText="Update Password"
      />
    </RowContainer>
  )
  return (
    <GenericEditScreen
      sort={data =>
        data.sort((d1, d2) =>
          d1 === undefined || d2 === undefined
            ? 1
            : (
                props.companyNameMap[d1.companyId] || d1.companyId
              ).toLowerCase() <=
              (props.companyNameMap[d2.companyId] || d1.companyId).toLowerCase()
            ? -1
            : 1
        )
      }
      title="eSuite Management"
      loadApiTask={retrieveTask}
      createApiTask={postESuiteMgmtInfo}
      updateApiTask={postESuiteMgmtInfo}
      deleteApiTask={deleteESuiteMgmtInfo}
      renderModal={renderModal}
      renderRow={renderRow}
      rowHeight={65}
      listHeightOffset={360}
      acceptFilter={acceptFilter}
      dataMatcher={d1 => d2 =>
        d1.companyId === d2.companyId &&
        d1.unitName === d2.unitName &&
        d1.market === d2.market}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
})

const WrappedESuiteMgmtScreen = props => (
  <SpinContext.Consumer>
    {({ spinning, setSpinning }) => (
      <ErrorContext.Consumer>
        {({ error, setError }) => (
          <ESuiteMgmt
            loading={spinning}
            setSpinning={setSpinning}
            error={error}
            setError={setError}
            {...props}
          />
        )}
      </ErrorContext.Consumer>
    )}
  </SpinContext.Consumer>
)

export default connect(mapStateToProps)(WrappedESuiteMgmtScreen)
